import { ActionTree, GetterTree, MutationTree } from 'vuex'
import Vue from 'vue'
import { NotificationOptions } from 'vue-notification'
import { ICartItem, ICartMessage } from '~/assets/interfaces/cart'
import { CART } from '~/assets/config/api-path'
import { IStateIndex } from '~/store/index'
import { filterUrl } from '~/assets/filters/url'
import { IProductToCart } from '~/assets/interfaces/products'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import { runIdle } from '~/assets/functions/runIndle'

interface IState {
  items: ICartItem[]
  isLoading: boolean
  isFirstLoaded: boolean
  canOrder: boolean
  bonus: number
  message?: ICartMessage
}

export const state = (): IState => ({
  items: [],
  isLoading: false,
  isFirstLoaded: false,
  canOrder: false,
  bonus: 0,
})

export const mutations: MutationTree<IState> = {
  setItems(state: IState, val: ICartItem[]) {
    state.items = val
  },
  setLoading(state: IState, val: boolean) {
    state.isLoading = val
  },
  setFirstLoaded(state: IState, val: boolean) {
    state.isFirstLoaded = val
  },
  setCanOrder(state: IState, val: boolean) {
    state.canOrder = val
  },
  setBonus(state: IState, val: boolean) {
    state.bonus = Number(val)
  },
  setMessage(state: IState, val: ICartMessage) {
    if (val) {
      Vue.set(state, 'message', val)
    } else {
      Vue.delete(state, 'message')
    }
  },
}

export const getters: GetterTree<IState, IStateIndex> = {
  itemsQuantity(state: IState): number {
    return state.items.length
  },
  getMessageText(state: IState): string | null {
    return state.message ? state.message.text : null
  },
}

export const actions: ActionTree<IState, IStateIndex> = {
  async getItems({ commit }) {
    commit('setLoading', true)
    const response = await this.$axios.$get(filterUrl(CART))

    runIdle(() => {
      commit('setItems', response.items || [])
      commit('setCanOrder', response.canOrder || false)
      commit('setBonus', response.bonus || 0)
      commit('setMessage', response.message || null)
      commit('setLoading', false)
      commit('setFirstLoaded', true)
    })
  },
  async toCart(
    { dispatch, commit },
    payload: IProductToCart | IProductToCart[]
  ): Promise<void> {
    commit('setLoading', true)
    let payloadTemp: IProductToCart | IProductToCart[] | null = null
    if (Array.isArray(payload)) {
      payloadTemp = payload
    } else {
      if (!payload.quantity && payload.quantity !== 0) {
        payload.quantity = 1
      }
      payloadTemp = {
        quantity: payload.quantity,
        id: payload.id,
        cartId: payload.cartId || null,
        services: payload.services,
      }
    }

    const toCart = async () => {
      const response = await this.$axios.$post(filterUrl(CART), payloadTemp)
      analyticsReachGoal('goal_product_toCart ')
      window.dataLayer = window.dataLayer || []
      if (response.cartAction && response.products && window.dataLayer) {
        window.dataLayer.push({
          ecommerce: {
            currencyCode: 'RUB',
            [response.cartAction]: {
              products: response.products || [],
            },
          },
        })
      }
      if (response.text) {
        Vue.notify({
          group: 'default',
          type: response.success ? 'info' : 'error',
          title: response.success ? false : 'Ошибка',
          text:
            response.text ||
            'Не удалось добавить товар в корзину. Попробуйте ещё раз',
        } as NotificationOptions)
      }
    }

    await dispatch('getItems', await toCart())
    commit('setLoading', false)
  },
}
